// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionPage_root__VJKeP","submitButton":"AuctionPage_submitButton__3Nkg9","selectcontrol":"AuctionPage_selectcontrol__3evy3"};